import React, { useContext, useEffect, useState } from "react";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { useDispatch, useSelector } from "react-redux";
import {
  CatchMessage,
  CheckUserType,
  JSONtoformdata,
  getValidData,
  tokenisValid,
} from "../../Shared/Methods";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import {
  DropdownService,
  ListDeviceInputPin,
} from "../../Services/ApiServices";
import classes from "./Device.module.css";
import { Col, Row } from "antd";
import Commontooltip from "../CommonTooltip/Commontooltip";
import editimg from "../../Assests/Images/pencil.png";
import Createdeviceinputpindetails from "../../Modals/Device/CreateDeviceInputPinDetails";
import Commonpopover from "../CommonPopOver/Commonpopover";
import CommonNodataFound from "../CommonNodataFound";
import { devicecontext } from "../../Screens/HomeScreen/ViewDevice";

function Inputpindetails({
  HandleViewDeviceData,
}: {
  HandleViewDeviceData: () => void;
}) {
  const contextdata = useContext(devicecontext);
  const { item } = contextdata || {};
  const dispatch = useDispatch();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [PinDetailsData, setPinDetailsData] = useState<any>({});
  const { items } = PinDetailsData;
  const [showmodal, setShowModal] = useState({
    isView: false,
    action: "",
    item: "",
  });
  const [DropDowns, setDropDowns] = useState({
    InputPin: [],
  });
  const [showConfirmModal, setShowConfirmModal] = useState<any>({
    isView: false,
    item: "",
    Itemname: "",
  });

  useEffect(() => {
    if (LoginData) {
      handleListPinDetails();
    }
  }, [LoginData]);

  const handleListPinDetails = (page = 1, size = 10, fortype = "") => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: item?.deviceId,
      for_type: fortype,
    };

    ListDeviceInputPin(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          setPinDetailsData(res?.data?.data);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getInputPinDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      for_alert: 1,
      device_id: item?.deviceId,
    };
    DropdownService(JSONtoformdata(finalObj), "pinDropdown")
      .then(async (res) => {
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              InputPin: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      {showmodal?.isView ? (
        <Createdeviceinputpindetails
          open={showmodal?.isView}
          closable={!showmodal?.isView}
          Action={showmodal?.action}
          onCancel={() => {
            setShowModal({
              isView: false,
              action: "",
              item: "",
            });
          }}
          handleSuccess={() => {
            handleListPinDetails();
            HandleViewDeviceData();
          }}
          items={showmodal?.item}
          DropDowns={DropDowns}
          Dropdowns={{ getInputPinDropDown }}
        />
      ) : null}

      <div className="primarycard h-100">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "12px",
          }}
        >
          <p style={{ margin: "0" }} className="device_heading_style">
            Pin Details
          </p>
        </div>

        <Row gutter={[16, 16]}>
          {items?.length > 0 ? (
            items?.map((ele: any, index: number) => {
              return (
                <>
                  <Col key={index} xxl={8} xl={8} lg={12} sm={24}>
                    <div
                      className={`${classes.device_alert_settings_container} h-100`}
                    >
                      <div>
                        <Commontooltip
                          children={
                            <p
                              style={{ fontWeight: 600 }}
                              className="cards_name_heading"
                            >
                              {ele?.pin_name}
                            </p>
                          }
                          msg={ele?.pin_name}
                          placement="topLeft"
                        />

                        {CheckUserType() ? (
                          <div>
                            <Commontooltip
                              children={
                                <img
                                  src={editimg}
                                  onClick={() => {
                                    setShowModal((pre: any) => {
                                      return {
                                        ...pre,
                                        isView: true,
                                        action: "Update Pin",
                                        item: ele,
                                      };
                                    });
                                  }}
                                  style={{ width: "15px", height: "15px" }}
                                  alt="editimg"
                                />
                              }
                              msg="Update"
                            />
                          </div>
                        ) : null}
                      </div>

                      <div style={{ padding: "12px" }}>
                        <div className="w-100">
                          <p>
                            Pin Number :{" "}
                            <span>{getValidData(ele?.pin_number)}</span>
                          </p>
                          <p className={classes.description}>
                            Description :{" "}
                            <Commonpopover
                              children={
                                <>
                                  <span style={{ cursor: "pointer" }}>
                                    {getValidData(ele?.description)}
                                  </span>
                                </>
                              }
                              content={getValidData(ele?.description)}
                              styles={{ display: "contents" }}
                              title="Description"
                              open={ele?.description ? true : false}
                            />
                          </p>
                        </div>
                      </div>

                      {/* <Commonpopover
                        children={
                          <>
                            <div style={{ padding: "12px" }}>
                              <div className="w-100">
                                <p>
                                  Pin Number :{" "}
                                  <span>{getValidData(ele?.pin_number)}</span>
                                </p>
                                <p className={classes.description}>
                                  Description :{" "}
                                  <span>{getValidData(ele?.description)}</span>
                                </p>
                              </div>
                            </div>
                          </>
                        }
                        content={getValidData(ele?.description)}
                        styles={{ display: "contents" }}
                        title="Description"
                      /> */}
                    </div>
                  </Col>
                </>
              );
            })
          ) : (
            <CommonNodataFound />
          )}
        </Row>
      </div>
    </>
  );
}

export default Inputpindetails;
